import React, { useEffect } from "react";
import { savedLayers } from "./mapGIS";
import "./StyleSwitcher.css";
import { Button } from "@mui/material";
import { Deck } from "@deck.gl/core";
import { Tile3DLayer } from "@deck.gl/geo-layers";
import { MapboxLayer } from "@deck.gl/mapbox";
import { CesiumIonLoader, Tiles3DLoader } from "@loaders.gl/3d-tiles";

const StyleSwitcher = ({ setMapStyleWasSwapped }) => {
  const pointcloud_point_size = 1;
  const ion_tiles_id = [43978];
  let SmuOn = true;
  const host = process.env.REACT_APP_HOST;
  /**
   * This function takes as input the id of a mapbox style and sets it, it also checks if it already exists before removing it and setting it again
   * @param {*} id
   * @returns
   */

  const swapStyle = (id) => {
    if (!window.map) {
      console.error("Map object is not defined.");
      return;
    }
    window.map.setStyle(id);
    let tileName = "Smuszewo";

    window.map.once("style.load", () => {
      if (SmuOn) {
        // Check if the layer already exists and remove it if it does
        const deck = new Deck({
          gl: window.map.painter.context.gl,
          layers: LoadLocalTilesets(pointcloud_point_size),
        });
        window.map.addLayer(new MapboxLayer({ id: tileName, deck }));
        window.map.setLayoutProperty(tileName, "visibility", "visible");
      }

      console.log("Style has been loaded");
      savedLayers.forEach((layer) => {
        const { Name, opacity } = layer;

        const sourceId = `${Name}-source`;
        //check if the layer exists before removing it to add it back again
        if (window.map.getSource(sourceId)) {
          window.map.removeLayer(`${Name}-layer`);
          window.map.removeSource(sourceId);
        }

        window.map.addSource(`${Name}-source`, {
          id: `${Name}-source`,
          type: "raster",
          tiles: [`${host}/getWMS/{bbox-epsg-3857}/${Name}`],
          tileSize: 512,
        });

        window.map.addLayer({
          id: `${Name}-layer`,
          type: "raster",
          source: `${Name}-source`,
          paint: {
            "raster-opacity": opacity,
          },
        });
      });

      console.log(window.map.getStyle()); // Log the new style after it has been applied
    });

    function LoadLocalTilesets(pointSize = 2) {
      let layer_list = [];
      // console.log("bike");
  
      layer_list.push(
        new Tile3DLayer({
          id: tileName,
          data: `${host}/get3dtiles/${tileName}`,
          sizeUnits: "meters",
          pointSize: pointSize,
          loader: Tiles3DLoader,
          loadOptions: { "3d-tiles": { isTileset: true } },
        })
      );
  
      return layer_list;
    }
  };
  return (
    <div className="styles-Container">
      <Button
        className="style-box"
        id="mapbox://styles/mapbox/light-v11"
        onClick={() => swapStyle("mapbox://styles/mapbox/light-v11")}
      >
        <img
          src={require("../LayerPictures/light.png")}
          alt="Light"
          style={{ width: "100%", height: "100%", borderRadius: "5px" }}
        />
      </Button>
      <Button
        className="style-box"
        id="mapbox://styles/mapbox/dark-v11"
        onClick={() => swapStyle("mapbox://styles/mapbox/dark-v11")}
      >
        <img
          src={require("../LayerPictures/dark.png")}
          alt="Dark"
          style={{ width: "100%", height: "100%", borderRadius: "5px" }}
        />
      </Button>

      <Button
        className="style-box"
        id="mapbox://styles/mapbox/outdoors-v12"
        onClick={() => swapStyle("mapbox://styles/mapbox/outdoors-v12")}
      >
        <img
          src={require("../LayerPictures/streets.png")}
          alt="Streets"
          style={{ width: "100%", height: "100%", borderRadius: "5px" }}
        />
      </Button>
      <Button
        className="style-box"
        id="mapbox://styles/mapbox/satellite-v9"
        onClick={() => swapStyle("mapbox://styles/mapbox/satellite-v9")}
      >
        <img
          src={require("../LayerPictures/satellite.png")}
          alt="Satellite"
          style={{ width: "100%", height: "100%", borderRadius: "5px" }}
        />
      </Button>
    </div>
  );
};

export default StyleSwitcher;
